import { applySnapshot, cast, getSnapshot, types } from 'mobx-state-tree';
import { api } from 'src/api';
import { createAsync } from 'src/utils/asyncModel';
import { YEmailValidateDefault } from 'src/utils/formValidation/yupValidators';
const getAllRoommatesRelatedToSpecificResidencyAsync = createAsync(body => {
  return async function getAllRoommatesRelatedToSpecificResidency(options) {
    const resp = await api.Roommates.getAllRoommatesRelatedToSpecificResidency(body, options);
    this.setRoommatesOwerviewUnit(resp.response);
    return resp;
  };
});
const updateRoommatesAssociatedWithResidencyByIdAsync = createAsync(body => {
  return async function updateRoommatesAssociatedWithResidencyById(options) {
    const resp = await api.Roommates.updateRoommatesAssociatedWithResidencyById(body, options);
    return resp;
  };
});
const RoommatesOwerviewUnit = types.model({
  firstName: types.string,
  lastName: types.string,
  email: types.string,
  id: types.maybeNull(types.string)
});
const RoommatesOwerviewValidation = types.model({
  firstName: types.maybeNull(types.string),
  lastName: types.maybeNull(types.string),
  email: types.maybeNull(types.string)
});
const RoommatesOwerviewTouched = types.model({
  firstName: types.boolean,
  lastName: types.boolean,
  email: types.boolean
});
const RoommatesStore = types.model('RoommatesStore', {
  getAllRoommatesRelatedToSpecificResidencyAsync,
  updateRoommatesAssociatedWithResidencyByIdAsync,
  roommatesOwerview: types.optional(types.array(RoommatesOwerviewUnit), []),
  roommatesOwerviewValidation: types.optional(types.array(RoommatesOwerviewValidation), []),
  roommatesOwerviewTouched: types.optional(types.array(RoommatesOwerviewTouched), [])
}).actions(store => {
  let afterLoadState;
  return {
    initAfterLoadState() {
      try {
        afterLoadState = getSnapshot(store);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    applyAfterLoadState() {
      try {
        applySnapshot(store, afterLoadState);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    resetState() {
      try {
        store.roommatesOwerview = cast([]);
        store.roommatesOwerviewValidation = cast([]);
        store.roommatesOwerviewTouched = cast([]);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    setRoommatesOwerviewUnit(data) {
      try {
        store.roommatesOwerview = cast([]);
        store.roommatesOwerviewValidation = cast([]);
        data.map(item => {
          store.roommatesOwerview.push({
            firstName: item.firstName,
            lastName: item.lastName,
            email: item.email,
            id: item.id ? item.id : null
          });
          store.roommatesOwerviewValidation.push({
            firstName: null,
            lastName: null,
            email: null
          });
          store.roommatesOwerviewTouched.push({
            firstName: false,
            lastName: false,
            email: false
          });
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    addRoommatesOwerviewUnit() {
      try {
        store.roommatesOwerview.push({
          firstName: '',
          lastName: '',
          email: '',
          id: null
        });
        store.roommatesOwerviewValidation.push({
          firstName: 'Field is required',
          lastName: 'Field is required',
          email: null
        });
        store.roommatesOwerviewTouched.push({
          firstName: false,
          lastName: false,
          email: false
        });
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    removeRoommatesOwerviewUnit(index) {
      try {
        store.roommatesOwerview.splice(index, 1);
        store.roommatesOwerviewValidation.splice(index, 1);
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeRoommatesOwerviewUnit(index, field, value) {
      try {
        store.roommatesOwerview[index][field] = value;
        if (field === 'email') {
          store.roommatesOwerviewValidation[index][field] = YEmailValidateDefault.isValidSync(value) ? null : 'Invalid email address.';
        } else {
          store.roommatesOwerviewValidation[index][field] = value.trim().length < 2 ? "".concat(field === 'firstName' ? 'First name' : 'Last name', " should be at least 2 characters.") : value.trim().length > 50 ? "".concat(field === 'firstName' ? 'First name' : 'Last name', " should not exceed 50 characters.") : null;
        }
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    },
    changeFieldTouched(index, field) {
      try {
        store.roommatesOwerviewTouched[index][field] = true;
      } catch (error) {
        console.error('STORE ERROR > ', error);
      }
    }
  };
});
export const roommates = types.optional(RoommatesStore, {});